import { render, staticRenderFns } from "./deleteMatchModalMultipl.vue?vue&type=template&id=6881527e&scoped=true"
import script from "./deleteMatchModalMultipl.vue?vue&type=script&lang=js"
export * from "./deleteMatchModalMultipl.vue?vue&type=script&lang=js"
import style0 from "./deleteMatchModalMultipl.vue?vue&type=style&index=0&id=6881527e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6881527e",
  null
  
)

export default component.exports